import React from 'react'

import Header from './Header'
import Main from './Main'

class App extends React.Component{
    render() {
          return (
              <div style={{height: '100vh'}}>
                  <Header/>
                  <Main/>
              </div>
          );
    }
}


export default App;



// WEBPACK FOOTER //
// ./src/Components/App.js